import { MobileComboBox, MobileComboBoxProps } from '@florencelabs/combo-box';
import { ReactElement } from 'react';
import { useSearchFilters } from '@provider-directory/contexts/SearchFiltersContext';

/**
 * Wraps a MobileCombobox to ensure it closes nicely when the Search Filters Drawer does.
 */
export const DrawerAwareMobileCombobox = <T extends object>(
  props: MobileComboBoxProps<T>,
): ReactElement => {
  const { isOpen: isDrawerOpen, setIsOpen } = useSearchFilters();
  const { onClose } = props;

  return (
    <MobileComboBox
      {...props}
      isOpen={isDrawerOpen && props.isOpen}
      showBackButton={true}
      onClose={() => {
        onClose?.();
        setIsOpen(false);
      }}
    />
  );
};
